import * as actions from "./actionsTypes";

const initialData = {
  loadermunicipalityUser: false,
  municipalityUser: null,
  municipalityUserFail: null,
  saveLoadermunicipalityUser: false,
  municipalityUserFormError: null,
};

export default function MunicipalityUserReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_MUNICIPALITYUSER:
      return { ...state, loaderMunicipalityUser: action.payload };

    case actions.GET_MUNICIPALITYUSER:
      return { ...state, municipalityUser: action.payload };

    case actions.GET_MUNICIPALITYUSER:
      return { ...state, municipalityUserFail: action.payload };

    case actions.SAVE_LOADER_MUNICIPALITYUSER:
      return { ...state, saveLoaderMunicipalityUser: action.payload };

    case actions.FORM_MUNICIPALITYUSER_FAIL:
      return { ...state, municipalityUserFormError: action.payload };

    default:
      return state;
  }
}
